export default {
  state:{
    amplitude:-3,
    modalOpen:false,
    project:null
  },
  mutations:{
    setProject(state, payload){
      state.project = payload.data;
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/index.js